import { OTPRequest } from "domain/entity/OTP";
import OTPRepository from "domain/repository/OTP";

export default class OTPUseCase {
    constructor(private repository: OTPRepository) { }

    postOTP(body: OTPRequest) {
        return this.repository.postOTP(body)
    }
}